import { ApiError } from '@community_dev/requests'
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

import { SSOConfigsResponse, getSSOConfigs } from 'api/sso'
import { QUERIES } from 'constants/queries'

export const useSSOConfigsQuery = (
  options?: UseQueryOptions<SSOConfigsResponse, ApiError, SSOConfigsResponse>,
): UseQueryResult<SSOConfigsResponse, ApiError> => {
  return useQuery<SSOConfigsResponse, ApiError>({
    queryKey: [QUERIES.SSO_CONFIG, 'LIST'],
    queryFn: () => getSSOConfigs(),
    ...options,
  })
}
